<div>
    <div class="zones-list-item">
        <div class="wrapper">
            <div class="icon-wrapper bg-style">
                <zone-icon [name]="zone().icon" [size]="16"/>
            </div>
            <div>{{ zone().name }}</div>
        </div>
        <app-chip [text]="zone().statusText" [background]="zone().statusBg"/>
    </div>
    @if (showEditActions()) {
        <form-value-button [subtitle]="labels.zoneName"
                           [value]="zone().name"
                           [transparent]="true"
                           (onClick)="actionSelected.emit('changeName')">
        </form-value-button>
        <form-card-button [subtitle]="labels.iconName"
                          [transparent]="true"
                          (onClick)="actionSelected.emit('changeIcon')">
            <div class="icon-wrapper bg-style">
                <zone-icon [name]="zone().icon" [size]="16"/>
            </div>
        </form-card-button>
    }
    @if (showTurnOffAndResetActions()) {
        <form-value-button [subtitle]="labels.turnOffZone"
                           [transparent]="true" (onClick)="actionSelected.emit('turnOff')"/>
        <form-value-button [subtitle]="labels.resetZone"
                           [transparent]="true" (onClick)="actionSelected.emit('reset')"/>
    }
    @if (showTurnOnAction()) {
        <form-value-button [subtitle]="labels.turnOnZone"
                           [transparent]="true" (onClick)="actionSelected.emit('turnOn')"/>
    }
    <form-action-buttons [justify]="'center'">
        <form-button [subtitle]="labels.cancel" [btnType]="'cancel'" (click)="goBack.emit()"/>
    </form-action-buttons>
</div>
